// サブメニュー開閉制御
// PC / SP ともに初期状態は閉じ、操作時に開閉する。
// クリック / タッチ時は SP のみトグルし、PC は通常のナビゲーション挙動を優先する。
// アクセシビリティを考慮し、見た目の開閉状態と aria-expanded / aria-hidden を同期する。
// 想定マークアップ: <li><a class="-has-submenu">..</a><ul class="submenu">...</ul></li>

document.addEventListener("DOMContentLoaded", () => {
  // ヘッダー専用 data 属性でスコープ分離
  const HEADER_ROOT_SELECTOR = "[data-header-nav-root]";
  const TRIGGER_SELECTOR = "[data-header-submenu-trigger]";
  const SUBMENU_SELECTOR = "[data-header-submenu]";
  const OPEN_CLASS = "-open";
  const DESKTOP_MIN = 769;
  const isDesktop = () => window.innerWidth >= DESKTOP_MIN;

  const headerRoot = document.querySelector(HEADER_ROOT_SELECTOR);
  if (!headerRoot) return;
  const triggers = headerRoot.querySelectorAll(TRIGGER_SELECTOR);
  if (!triggers.length) return;

  // 開いているサブメニューをまとめて閉じる。
  // except を渡した場合は、そのサブメニューだけ開いたまま残す。
  function closeAll(except) {
    headerRoot
      .querySelectorAll(SUBMENU_SELECTOR + "." + OPEN_CLASS)
      .forEach((ul) => {
        if (!except || ul !== except) {
          const li = ul.closest("[data-header-submenu-wrapper]");
          const trigger = li
            ? li.querySelector(":scope > " + TRIGGER_SELECTOR)
            : null;

          // CSS クラスと ARIA 属性を同時に更新して、表示状態と支援技術向け状態を一致させる。
          ul.classList.remove(OPEN_CLASS);
          ul.setAttribute("aria-hidden", "true");
          if (trigger) trigger.setAttribute("aria-expanded", "false");
        }
      });
  }

  triggers.forEach((trigger) => {
    const li = trigger.closest("[data-header-submenu-wrapper]");
    if (!li) return;
    const submenu = li.querySelector(":scope > " + SUBMENU_SELECTOR);
    if (!submenu) return;

    let hideTimer = null;

    // 1つのサブメニューの開閉状態をまとめて更新する共通処理。
    const setOpenState = (isOpen) => {
      submenu.classList.toggle(OPEN_CLASS, isOpen);
      trigger.setAttribute("aria-expanded", isOpen ? "true" : "false");
      submenu.setAttribute("aria-hidden", isOpen ? "false" : "true");
    };

    // サブメニューを開く。PC では他のサブメニューを閉じて、同時に1つだけ開く。
    const open = () => {
      if (hideTimer) {
        clearTimeout(hideTimer);
        hideTimer = null;
      }
      if (isDesktop()) {
        // デスクトップはアコーディオン
        closeAll(submenu);
      }
      setOpenState(true);
    };
    const scheduleClose = () => {
      if (!isDesktop()) return; // モバイル時はホバー閉じ不要
      if (hideTimer) clearTimeout(hideTimer);
      hideTimer = setTimeout(() => {
        setOpenState(false);
      }, 150); // マウス移動の遊び時間
    };

    // 外側クリックや ESC など、待ち時間なしで閉じたい時に使う。
    const immediateClose = () => {
      if (hideTimer) {
        clearTimeout(hideTimer);
        hideTimer = null;
      }
      setOpenState(false);
    };
    const toggle = () => {
      if (submenu.classList.contains(OPEN_CLASS)) {
        immediateClose();
      } else {
        open();
      }
    };

    // ARIA 初期化。PC / SP ともに初期状態は閉じる。
    trigger.setAttribute("aria-haspopup", "true");
    submenu.setAttribute("role", "menu");
    setOpenState(false);

    // ホバー (デスクトップ幅のみ有効)
    const hoverOpen = () => {
      if (isDesktop()) open();
    };
    const hoverScheduleClose = () => {
      if (isDesktop()) scheduleClose();
    };
    trigger.addEventListener("mouseenter", hoverOpen);
    trigger.addEventListener("mouseleave", hoverScheduleClose);
    submenu.addEventListener("mouseenter", hoverOpen);
    submenu.addEventListener("mouseleave", hoverScheduleClose);

    // フォーカス (キーボード操作)
    trigger.addEventListener("focus", () => {
      if (isDesktop()) open();
    });
    // サブメニュー内フォーカス維持
    const focusables = submenu.querySelectorAll(
      'a, button, [tabindex]:not([tabindex="-1"])',
    );
    focusables.forEach((el) => {
      el.addEventListener("focus", open);
      el.addEventListener("blur", (e) => {
        // 関連ターゲットがサブメニュー内に無ければ閉じる
        const next = e.relatedTarget;
        if (!next || !submenu.contains(next)) scheduleClose();
      });
    });

    // クリック / タッチ: 最初のタップで開く、開いている状態で再タップなら閉じる（href が無い想定）
    trigger.addEventListener("click", (e) => {
      if (isDesktop()) {
        // デスクトップ: クリックはナビ遷移優先。必要なら preventDefault で toggle へ変更可。
        return;
      }
      // モバイル: クリック/タップでトグル (ナビ遷移はさせない)
      e.preventDefault();
      toggle();
    });
  });

  // 外側クリックで全て閉じる (ヘッダー領域のみ / フッターは対象外)
  document.addEventListener("click", (e) => {
    // モバイルでは外側クリック閉じ無効（要件）
    if (!isDesktop()) return;
    const inHeaderMenu = e.target.closest(HEADER_ROOT_SELECTOR);
    const inFooterMenu = e.target.closest("[data-footer-submenu-root]");
    if (!inHeaderMenu && !inFooterMenu) {
      closeAll();
    }
  });

  // ESC キーで閉じる
  document.addEventListener("keydown", (e) => {
    if (!isDesktop()) return; // モバイル幅では無効
    if (e.key === "Escape") {
      closeAll();
    }
  });

  // 幅が閾値を跨いだ時は、常に閉じた状態へ戻す
  window.addEventListener("resize", () => {
    closeAll();
  });
});
